import type { TextVariable } from '@carboncopyco/types';
import { InputTextField, type InputTextFieldProps } from '@carboncopyco/ui';
import { useField } from 'formik';

export interface TextVariableInputProps
  extends Pick<InputTextFieldProps, 'name'> {
  readOnly?: boolean;
}

export const TextVariableInput = ({
  readOnly,
  name,
}: TextVariableInputProps) => {
  const [valueField] = useField<TextVariable['value']>(name);

  return (
    <InputTextField
      disabled={readOnly}
      name={valueField.name}
      value={valueField.value}
      noLabels
      noAddedHeight
      placeholder="Insert a new value"
    />
  );
};
